import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import { AxiosError } from "axios";
import getErrorProperty from "./config/getErrorProperty";
import { getAuth } from "firebase/auth";
import { TBookmarkContentsResponse } from "../../api/bookmarks";

export type TApiBookmarkContentsResult = {
  result?: TBookmarkContentsResponse;
};

export const fetchBookmarkContents = async (
  offset: number,
  limit?: number
): Promise<TApiResult & TApiBookmarkContentsResult> => {
  const bodyQuery = {
    skip: offset,
    limit: limit,
  };
  const query = {
    query: { ...bodyQuery },
  };

  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  const authHeader = token && { headers: { Authorization: `Bearer ${token}` } };
  return await client()
    .bookmarks.get({ ...query, ...authHeader })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "fetchContents");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
